export default __webpack_public_path__ + "static/hp-brand-deck-20-3f8497e7df3488ee2713d16cd4217df3.png";